import React, { useState } from "react";

const subjectMaster = {

    "Unit Test 1": {
        "CBSE": {
            "10th": [
                "Telugu",
                "Hindi",
                "English",
                "Mathematics",
                "Science"
            ]
        }
    },


    "Semester 1": {
        "CBSE": {

            "10th": [
                "Telugu",
                "Hindi",
                "English",
                "Mathematics",
                "Science",
                "Social"
            ],

            "10th": [
                "Telugu",
                "Hindi",
                "English",
                "Mathematics",
                "Science",
                "Social"
            ]

        }
    },


    "Final Exam": {

        "State Board": {

            "12th Science": [
                "English",
                "Physics",
                "Chemistry",
                "Mathematics",
                "Biology"
            ]

        }

    }

};




const studentsList = [

    {
        id: 1,
        name: "Rahul Sharma",
        rollNo: "101",
        className: "10th",
        section: "A",
        curriculum: "CBSE"
    },

    {
        id: 2,
        name: "Vignika",
        rollNo: "102",
        className: "10th",
        section: "A",
        curriculum: "CBSE"
    },

    {
        id: 3,
        name: "Abhi",
        rollNo: "103",
        className: "10th",
        section: "B",
        curriculum: "CBSE"
    }

];




const MarksGradeEntry = () => {


    const [records, setRecords] = useState([]);

    const [subjects, setSubjects] = useState([]);

    const [marks, setMarks] = useState({});


    const [showModal, setShowModal] = useState(false);

    const [editId, setEditId] = useState(null);


    const [search, setSearch] = useState("");



    const [formData, setFormData] = useState({

        exam: "",
        curriculum: "",
        className: "",
        section: "",
        student: ""

    });





    const calculateGrade = (percentage) => {

        if (percentage >= 90)
            return "A+";

        if (percentage >= 80)
            return "A";

        if (percentage >= 70)
            return "B";

        if (percentage >= 60)
            return "C";

        if (percentage >= 40)
            return "D";

        return "F";

    };






    const loadSubjects = (exam, curriculum, className) => {


        if (
            subjectMaster[exam] &&
            subjectMaster[exam][curriculum] &&
            subjectMaster[exam][curriculum][className]
        ) {

            setSubjects(
                subjectMaster[exam]
                [curriculum]
                [className]
            );

        }
        else {
            setSubjects([]);
        }

    };







    const handleChange = (e) => {


        const { name, value } = e.target;


        const updated = {

            ...formData,

            [name]: value

        };


        setFormData(updated);



        if (
            name === "exam" ||
            name === "curriculum" ||
            name === "className"
        ) {

            loadSubjects(

                updated.exam,

                updated.curriculum,

                updated.className

            );

        }


    };








    const handleMarks = (subject, value) => {


        setMarks({

            ...marks,

            [subject]: value

        });


    };









    const saveMarks = (e) => {


        e.preventDefault();



        const student =
            studentsList.find(
                s => s.id === Number(formData.student)
            );




        let total = 0;


        Object.values(marks)
            .forEach(
                m => {
                    total += Number(m || 0)
                }
            );

        let percentage =
            (total / (subjects.length * 100)) * 100;
        let data = {


            id: Date.now(),

            exam: formData.exam,

            curriculum: formData.curriculum,

            className: formData.className,

            section: formData.section,


            studentName: student?.name,


            rollNo: student?.rollNo,


            subjects: marks,


            total: total,


            percentage:
                percentage.toFixed(2),


            grade:
                calculateGrade(percentage),


            status:
                percentage >= 40
                    ?
                    "Pass"
                    :
                    "Fail"


        };




        setRecords([

            ...records,

            data

        ]);



        setMarks({});

        setFormData({

            exam: "",
            curriculum: "",
            className: "",
            section: "",
            student: ""

        });

        setSubjects([]);

    };









    const deleteRecord = (id) => {


        setRecords(

            records.filter(
                r => r.id !== id
            )

        );


    };









    const filteredRecords =
        records.filter(item =>

            item.studentName
                .toLowerCase()
                .includes(
                    search.toLowerCase()
                )

        );







    return (

        <div className="mt-4">


            {/* <h3 className="mb-4">
                Marks & Grade Entry
            </h3>
 */}



            <div className="card mb-4">


                <div className="card-header">

                    Enter Student Marks

                </div>



                <div className="card-body">


                    <form onSubmit={saveMarks}>


                        <div className="row g-3">


                        <div className="col-md-2">

                                <label>Academic year</label>

                                <select
                                    className="form-select"
                                    name="academic_year"
                                    value={formData.academic_year}
                                    onChange={handleChange}
                                >

                                    <option value="">
                                        2026-27
                                    </option>

                                    <option>
                                        2025-26
                                    </option>

                                    <option>
                                       2024-25
                                    </option>

                                    <option>
                                        2023-24
                                    </option>


                                </select>

                            </div>


                            <div className="col-md-2">

                                <label>Exam</label>

                                <select
                                    className="form-select"
                                    name="exam"
                                    value={formData.exam}
                                    onChange={handleChange}
                                >

                                    <option value="">
                                        Select
                                    </option>

                                    <option>
                                        Unit Test 1
                                    </option>

                                    <option>
                                        Semester 1
                                    </option>

                                    <option>
                                        Final Exam
                                    </option>


                                </select>

                            </div>





                            <div className="col-md-2">

                                <label>Curriculum</label>

                                <select
                                    className="form-select"
                                    name="curriculum"
                                    value={formData.curriculum}
                                    onChange={handleChange}
                                >

                                    <option value="">
                                        Select
                                    </option>

                                    <option>
                                        CBSE
                                    </option>

                                    <option>
                                        State Board
                                    </option>

                                </select>


                            </div>





                            <div className="col-md-2">

                                <label>Class</label>

                                <select
                                    className="form-select"
                                    name="className"
                                    value={formData.className}
                                    onChange={handleChange}
                                >

                                    <option value="">
                                        Select
                                    </option>

                                    <option>
                                        10th
                                    </option>

                                    <option>
                                        10th 
                                    </option>

                                    <option>
                                        12th    
                                    </option>
                                </select>
                            </div> 
                            
                             <div className="col-md-1">

                                <label>Section</label>

                                <select
                                    className="form-select"
                                    name="section"
                                    value={formData.section}
                                    onChange={handleChange}
                                >


                                    <option value="">
                                        Select
                                    </option>

                                    <option>
                                        A
                                    </option>

                                    <option>
                                        B
                                    </option>

                                    <option>
                                        C
                                    </option>


                                </select>

                            </div>

                            <div className="col-md-3">
                                <label>Student</label>
                                <select
                                    className="form-select"
                                    name="student"
                                    value={formData.student}
                                    onChange={handleChange}
                                >
                                    <option value="">
                                        Select Student
                                    </option>


                                    {
                                        studentsList
                                            .filter(

                                                s =>
                                                    s.className === formData.className
                                                    &&
                                                    s.section === formData.section
                                            )

                                            .map(student => (
                                                <option
                                                    key={student.id}
                                                    value={student.id}
                                                >

                                                    {student.name}

                                                </option>
                                            ))
                                    }
                                </select>
                            </div>
                        </div>




                        {subjects.length > 0 && (
                            <div className="shadow-sm bg-light">

                                <div className="row p-3 mt-3">
                                    <div className="col-md-12 mb-3">
                                        <h5>  Subjects & Marks </h5>
                                    </div>
                                    {
                                        subjects.map(subject => (
                                            <div className="col-md-2 mb-3"
                                                key={subject}
                                            >


                                                <label className="fw-semibold">

                                                    {subject}

                                                </label>


                                                <input

                                                    type="number"

                                                    className="form-control"

                                                    placeholder={`Enter ${subject} marks`}

                                                    value={
                                                        marks[subject] || ""
                                                    }

                                                    onChange={
                                                        e =>
                                                            handleMarks(
                                                                subject,
                                                                e.target.value
                                                            )
                                                    }

                                                />


                                            </div>


                                        ))


                                    }


                                </div>
                            </div>
                        )}

                        <div className="text-center mt-4">
                            <button className="btn btn-primary">
                                Save Marks
                            </button>
                        </div>

                    </form>
                </div>
            </div>

            <div className="card">
                <div className="card-header">
                    <h5> Marks Report </h5>


                    <input

                        className="form-control w-25"

                        placeholder="Search Student"

                        value={search}

                        onChange={
                            e => setSearch(e.target.value)
                        }

                    />
                </div>

                <div className="card-body">
                    <div className="table-responsive">


                        <table className="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Student</th>
                                    <th>Roll</th>
                                    <th>Class</th>
                                    <th>Exam</th>
                                    <th>Subjects</th>
                                    <th>Total</th>
                                    <th>%</th>
                                    <th>Grade</th>
                                    <th>Status</th>
                                    <th>Action</th>

                                </tr>


                            </thead>




                            <tbody>


                                {

                                    filteredRecords.map((item, index) => (


                                        <tr key={item.id}>


                                            <td>
                                                {index + 1}
                                            </td>


                                            <td>
                                                {item.studentName}
                                            </td>


                                            <td>
                                                {item.rollNo}
                                            </td>


                                            <td>
                                                {item.className}
                                            </td>


                                            <td>
                                                {item.exam}
                                            </td>



                                            <td>

                                                {

                                                    Object.entries(item.subjects)
                                                        .map(([sub, mark]) => (

                                                            <div key={sub}>

                                                                {sub} : {mark}

                                                            </div>

                                                        ))

                                                }


                                            </td>



                                            <td>
                                                {item.total}
                                            </td>


                                            <td>
                                                {item.percentage}%
                                            </td>



                                            <td>

                                                <span className="badge bg-info">

                                                    {item.grade}

                                                </span>

                                            </td>



                                            <td>

                                                <span className={
                                                    item.status === "Pass"
                                                        ?
                                                        "badge bg-success"
                                                        :
                                                        "badge bg-danger"
                                                }
                                                >

                                                    {item.status}

                                                </span>

                                            </td>



                                            <td>


                                                <button

                                                    className="btn btn-sm btn-danger"

                                                    onClick={() =>
                                                        deleteRecord(item.id)
                                                    }

                                                >

                                                    Delete

                                                </button>


                                            </td>



                                        </tr>


                                    ))

                                }



                            </tbody>


                        </table>


                    </div>
                </div>






            </div>


        </div>


    );


};


export default MarksGradeEntry;